import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LegendCont, LegendText, GroupCont } from './ReportPRMGroupDistribution.styles';
import { getPRMBarChartData } from '../../helpers/helpers';
import PageSection from '../../HOC/PageSection/PageSection';
import { useFilters } from '../../hooks/useFilters';
import { IPrmAnalysisResults } from '../../services/reports';
import Link from '../Link/Link';
import PRMBarChart from '../PRMBarChart/PRMBarChart';
import SafeHtml from '../SafeHtml/SafeHtml';

interface IReportPRMGroupDistibution {
  survey: string;
  prmResults: IPrmAnalysisResults;
}

const ReportPRMGroupDistribution: FC<IReportPRMGroupDistibution> = ({ survey, prmResults }) => {
  const { currentFilters, applyAndMergeFilters } = useFilters();
  const { i18n, t } = useTranslation();

  const getFilters = useMemo(() => {
    const prm = currentFilters?.prm as string | null;

    if (prm) {
      const prmFilters = JSON.parse(prm) as {
        slide: number;
        groupDistribution: { legend: boolean };
      };

      return {
        slide: prmFilters?.slide || 0,
        groupDistribution: prmFilters?.groupDistribution || {},
      };
    }
  }, [currentFilters?.prm]);

  const isLegendExpandedFromUrl = getFilters?.groupDistribution?.legend || false;

  const { chart, reference } = getPRMBarChartData(survey, prmResults, { lng: i18n.language });

  return (
    <PageSection title={t('report.prm.prmGroupDistribution')}>
      <>
        <LegendCont id="LegendCont">
          <LegendText id="LegendText" isExpanded={isLegendExpandedFromUrl}>
            <SafeHtml html={prmResults?.description} />
          </LegendText>
          <Link
            text={isLegendExpandedFromUrl ? t('report.prm.showLess') : t('report.prm.showMore')}
            onClick={() =>
              applyAndMergeFilters('prm', 'groupDistribution', { legend: !isLegendExpandedFromUrl })
            }
          />
        </LegendCont>
        <GroupCont id="GroupCont">
          {chart && reference ? <PRMBarChart data={chart} {...{ reference }} /> : null}
        </GroupCont>
      </>
    </PageSection>
  );
};

export default ReportPRMGroupDistribution;
